export class RegisteredUserFirebase{
  firstName:string;
  lastName:string;
  email:string;
  docid:string
}
